import { useNavigate } from "react-router-dom";

const IconLock = () => (
  <svg width="24" height="24" viewBox="0 0 14 14" fill="none">
    <rect x="2.5" y="6" width="9" height="6.5" rx="1" stroke="currentColor" strokeWidth="1.3" />
    <path d="M4.5 6V4a2.5 2.5 0 0 1 5 0v2" stroke="currentColor" strokeWidth="1.3" />
  </svg>
);

export default function AuthRequred() {
  const navigate = useNavigate();
  return (
    <div className="p-content" style={{ display: "flex", alignItems: "center", justifyContent: "center", minHeight: "60vh" }}>
      <div style={{ textAlign: "center", maxWidth: 360 }}>
        <div style={{ width: 64, height: 64, borderRadius: "50%", background: "var(--cream)", border: "1px solid var(--line)", display: "grid", placeItems: "center", margin: "0 auto 24px", color: "var(--maroon)" }}>
          <IconLock />
        </div>
        <h2 style={{ fontFamily: "var(--serif)", fontSize: 28, color: "var(--maroon)", marginBottom: 12, fontWeight: 500 }}>
          Sign in required
        </h2>
        <p style={{ fontSize: 15, color: "var(--ink-soft)", lineHeight: 1.6, marginBottom: 28 }}>
          You need to be signed in to access the secure portal.
        </p>
        <button
          className="p-btn p-btn-primary"
          style={{ padding: "12px 28px", fontSize: 14 }}
          onClick={() => navigate("/login")}
        >
          Sign in to continue
        </button>
      </div>
    </div>
  );
}
